import {Injectable, NgZone} from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import {Store} from '@ngxs/store';
import {AuthenticationService} from '../../service/auth.service';
import {AccountState} from '../../states/account.state';
import {SwalUtil} from '../../util/swal-util';

@Injectable({
  providedIn: 'root'
})
export class AccountLevel3Guard  {

  constructor(
    private router: Router, private store: Store,
    private authenticationService: AuthenticationService,
    private ngZone: NgZone, private swalUtil: SwalUtil
  ) {
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    const accountStatus = this.store.selectSnapshot(AccountState.getAccountStatus);
    if (accountStatus) {
      const idLevel = Number(accountStatus.level.id);
      if (idLevel >= 3) {
        this.showMessage();
        this.router.navigate(['/home']);
      }
      if (idLevel === 2.5) {
        this.showMessage2()
        this.router.navigate(['/home']);
    }else {
        return true;
      }
    }
  }

  protected showMessage() {
    SwalUtil.fireGenericMessage('Atención', '');
  }
  protected showMessage2() {
    SwalUtil.fireGenericMessage('Atención', '');
  }
}
